import React, { useEffect, useRef } from 'react';
import videojs from 'video.js';

import 'video.js/dist/video-js.css';
// import 'videojs-youtube';

const VideoPlayer = ({ options={}, videoUrl='' }) => {
  const videoReference = useRef(null);
  const playerReference = useRef(null);
  const videoType = videoUrl?.includes('m3u8')
    ? 'application/x-mpegURL'
    : videoUrl?.includes('youtube')
    ? 'video/youtube'
    : 'video/mp4';

  useEffect(() => {
    // Initializing video.js player
    if (!playerReference.current) {
      const videoElement = document.createElement('video-js');
      videoElement.classList.add('vjs-big-play-centered');
      videoElement.setAttribute('playsinline', ''); // Ensure the video plays inline on iOS browsers
      videoReference.current && videoReference.current.appendChild(videoElement);
      const player = playerReference.current = videojs(
        videoElement,
        {
          sources: [{
            src: videoUrl,
            type: videoType,
          }],
          controls: true,
          autoplay: false,
          preload: 'auto',
          aspectRatio: '16:9',
          ...options,
          html5: {
            vhs: {
              overrideNative: true, // Force VHS to handle HLS playback even on platforms with native support
            },
            nativeAudioTracks: false,
            nativeVideoTracks: false,
          },
        },
        () => {
          videojs.log('Video player is ready');
        }
      );
    } else {
      const player = playerReference.current;
      player.autoplay(options.autoplay);
      player.src(options.sources);
    }
  }, [options, videoReference]);


  useEffect(() => {
    const player = playerReference.current;
    return () => {
      if (player) {
        player.dispose();
        playerReference.current = undefined;
      }
    };
  }, [playerReference]);

  if (!videoUrl) {
    return null;
  }

  return (
    <div data-vjs-player>
      <div ref={videoReference} />
    </div>
  );
};

export default VideoPlayer;

// References: https://videojs.com/guides/react/
